import linkifyHtml from 'linkify-html';
import DOMPurify from 'dompurify';

const linkifyOptions = {
  defaultProtocol: 'https',
  target: {
    url: '_blank'
  },
  rel: 'noopener noreferrer'
};

/**
 * Normaliza hrefs que son dominios sin protocolo (ej. www.google.es) para que
 * no se interpreten como rutas relativas de la web actual.
 */
function normalizeBareUrls(htmlString) {
  if (!htmlString) return '';
  return htmlString.replace(
    /\bhref=["']([^"']+)["']/gi,
    (match, url) => {
      const u = url.trim();
      // Dejar intactos: protocolos, anclas, rutas absolutas, mailto, tel
      if (/^(https?:|#|\/|mailto:|tel:)/i.test(u)) return match;
      // Si parece un dominio (empieza por www. o por letras y tiene punto), añadir https://
      if (/^www\./i.test(u) || /^[a-z0-9][-a-z0-9]*\.[a-z]{2,}/i.test(u)) {
        const protocol = /^[a-z][-a-z0-9+.]*:/i.test(u) ? '' : 'https://';
        return `href="${protocol}${u}"`;
      }
      return match;
    }
  );
}

/**
 * Sanitiza y convierte enlaces en contenido HTML.
 * - Permite formato de Quill: span, style (color, background, etc.).
 * - Normaliza enlaces sin protocolo para que apunten a la URL correcta.
 */
export function linkifyContent(htmlString) {
  if (!htmlString) return '';

  const withFixedLinks = normalizeBareUrls(htmlString);

  const sanitized = DOMPurify.sanitize(withFixedLinks, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 's', 'a', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'span'  // Quill usa span para color, tamaño, fuente
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'style', 'class']
  });

  return linkifyHtml(sanitized, linkifyOptions);
}
